import React from 'react';
import '../Colors.css';

const ThumbDown = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslPink' d="M447.914 975.159c-26.476-123.179-161.143-279.456-231.551-348.473-69.786-68.439-64.299-158.047-165.435-158.047v-368.822c194.291 0 144.923-99.824 561.13-99.824 244.238 0 313.453 73.030 313.453 106.226 0 33.246-22.040 39.022-22.040 61.185s68.215 29.276 68.215 82.961c0 53.689-50.611 62.095-50.611 80.862 0 18.72 51.995 16.527 51.995 83.68 0 67.059-66.55 53.729-66.55 74.172 0 20.447 17.799 24.457 17.799 77.756 0 33.007-27.386 68.638-114.151 62.717-85.916-5.87-126.654-13.948-227.591-25.692-83.77-9.747-88.535 66.336-57.291 133.395 36.349 77.994 84.861 167.411 42.075 238.812-26.429 44.083-101.75 81.531-119.447-0.907z"/>
    </svg>
  );
};

export default ThumbDown;